export class Param {
    public __classname__: string = 'Param';

    public Name : string | null = null;
	public Value: string | null = null;

    constructor(
        Name : string | null = null, 
        Value: string | null = null
    ) {
        this.Name = Name;
        this.Value = Value;
    }
}